export const SHOP_ITEM_KEYS = ['shopItem', 'shopItem2', 'shopItem3'];
export const SHOP_ITEM_IMAGE_SWAP_DELAY_MS = 500;
export const SHOP_ITEM_UI_SHOW_DELAY_MS = 200;
